/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalCommonCustomAttributeDecimalTypeValue interface.
 */
export function instanceOfInternalCommonCustomAttributeDecimalTypeValue(value) {
    return true;
}
export function InternalCommonCustomAttributeDecimalTypeValueFromJSON(json) {
    return InternalCommonCustomAttributeDecimalTypeValueFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDecimalTypeValueFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InternalCommonCustomAttributeDecimalTypeValueToJSON(json) {
    return InternalCommonCustomAttributeDecimalTypeValueToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDecimalTypeValueToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
